/**
 * Company Pricing API Client
 * Price zones and code pattern pricing
 */

import apiClient from '../client';

// ===== PRICE ZONES =====

export const getPriceZones = async (companyId) => {
  const response = await apiClient.get(`/wholesale/companies/${companyId}/price-zones`);
  return response.data?.data || response.data || [];
};

export const createPriceZone = async (companyId, data) => {
  const response = await apiClient.post(`/wholesale/companies/${companyId}/price-zones`, data);
  return response.data?.data || response.data;
};

export const updatePriceZone = async (companyId, zoneId, data) => {
  const response = await apiClient.patch(`/wholesale/companies/${companyId}/price-zones/${zoneId}`, data);
  return response.data?.data || response.data;
};

export const deletePriceZone = async (companyId, zoneId) => {
  const response = await apiClient.delete(`/wholesale/companies/${companyId}/price-zones/${zoneId}`);
  return response.data;
};

// ===== CODE PRICES =====

export const getCodePrices = async (companyId) => {
  const response = await apiClient.get(`/wholesale/companies/${companyId}/code-prices`);
  return response.data?.data || response.data || [];
};

export const createCodePrice = async (companyId, data) => {
  const response = await apiClient.post(`/wholesale/companies/${companyId}/code-prices`, data);
  return response.data?.data || response.data;
};

export const updateCodePrice = async (companyId, priceId, data) => {
  const response = await apiClient.patch(`/wholesale/companies/${companyId}/code-prices/${priceId}`, data);
  return response.data?.data || response.data;
};

export const deleteCodePrice = async (companyId, priceId) => {
  const response = await apiClient.delete(`/wholesale/companies/${companyId}/code-prices/${priceId}`);
  return response.data;
};

// ===== PRICE CALCULATION =====

export const calculatePrice = async (companyId, tileCode, zoneId) => {
  const response = await apiClient.get(`/wholesale/companies/${companyId}/calculate-price`, {
    params: { tile_code: tileCode, zone_id: zoneId }
  });
  return response.data?.data || response.data;
};
